import { RouteObject } from "react-router";
import { Lazy } from "@shared/components/ui/lazy";

const DispatchDashboard = Lazy(() => import("@shared/features/dispatch/pages/dashboard"), "DispatchDashboard");
const DispatchInventory = Lazy(() => import("@shared/features/dispatch/pages/dispatch-inventory"), "DispatchInventory");
const DispatchInventoryShop = Lazy(() => import("@shared/features/dispatch/pages/dispatch-inventory-shop"), "DispatchInventoryShop");
const DispatchMap = Lazy(() => import("@shared/features/dispatch/pages/dispatch-map"), "DispatchMap");
const DispatchTeam = Lazy(() => import("@shared/features/dispatch/pages/dispatch-team"), "DispatchTeam");
const UserSettings = Lazy(() => import("@shared/features/user/pages/user-settings"), "UserSettings");

export const getDispatchRoutes = (): RouteObject[] => {
  return [
    { index: true, element: <DispatchDashboard /> },
    { path: "map", element: <DispatchMap /> },
    { path: "team", element: <DispatchTeam /> },
    { path: "inventory", element: <DispatchInventory /> },
    {
      path: "inventory/supply-request/new",
      element: <DispatchInventoryShop />,
    },
    { path: "user/settings", element: <UserSettings /> },
  ];
};
